import script from "./add-filter-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-filter-group.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__